export default __webpack_public_path__ + "static/media/culture-bg-icon.f1b76813.svg";